import { render, staticRenderFns } from "./InstructionView.vue?vue&type=template&id=4bf861b6&scoped=true&"
import script from "./InstructionView.vue?vue&type=script&lang=js&"
export * from "./InstructionView.vue?vue&type=script&lang=js&"
import style0 from "./InstructionView.vue?vue&type=style&index=0&id=4bf861b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf861b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
